// extracted by mini-css-extract-plugin
export default {"departments":"zF-z","departmentHeading":"AF-z","departmentSection":"BF-z","departmentName":"CF-z","departmentLink":"DF-z","expandIcon":"EF-z"};